const companies = [
  'leybold',
  'edwards',
];

export const company = companies.find(company => window.location.host.includes(company)) || 'atlascopco';



// WEBPACK FOOTER //
// ./src/utils/brand.js